import http from "./httpService";

const endPoint = "/api/v1/Categories";


export async function addCategory(request) {
    return await http.post(endPoint, request);
}

export async function getAllCategories(customer, organization) {
    return await http.get(`${endPoint}/All`, {
        headers: {
            'customerId': customer,
            'organizationId': organization
        }
    });
}

export async function getActiveCategories(customer, organization) {
    return await http.get(`${endPoint}`, {
        headers: {
            'customerId': customer,
            'organizationId': organization
        }
    });
}

export function updateCategory(id, request) {
    return http.put(`${endPoint}/${id}`, request );
}

export function updateCategoryImage(id, request) {
    return http.put(`${endPoint}/${id}/Image`, request );
}

export async function getCategoriesProducts(id, onlyActive, customer, organization) {
    return await http.get(`${endPoint}/${id}/Products`, {
        params: {
            id: id,
            onlyActive: onlyActive,
            customerId: customer,
            organizationId: organization
        }
    });
}

export default { addCategory, getAllCategories, getActiveCategories, updateCategory, updateCategoryImage, getCategoriesProducts };


// WEBPACK FOOTER //
// ./src/services/CategoriesService.js